import './MessageSlider.scss';
import React from 'react';

interface IProps {
  message: Julius.Content.MessageSlider;
}

const MessageSlider: React.SFC<IProps> = ({ 
  message,
}) => {

  if (!message || !message.sliderText) {
    return null;
  }

  const { sliderText, backgroundColor } = message;
  const colorStyle = backgroundColor ? backgroundColor.toLowerCase() : 'black';

  return (
    <div className={ `message-slider ${ colorStyle }` }>
      <div className='text'>{ sliderText }</div>
    </div>
  );
};

export default MessageSlider;


// WEBPACK FOOTER //
// ./src/components/MessageSlider/MessageSlider.tsx